'use strict';

(function (angular) {
  angular.module('zp').service('ShopService', shopService);

  /**@ngInject */
  function shopService($http) {
    var service = this;

    service.getAll = getAll;
    service.getOne = getOne;

    /////////////////////////////////

    function getAll() {
      return $http.get('/data/shop.json').then(function (response) {
        return response.data;
      });
    }

    function getOne(name) {
      return $http.get('/data/shop.json').then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].name === name) {
            return response.data[i];
          }
        }
        return null;
      });
    }
  }
})(window.angular);